export default "__VITE_ASSET__CpnfzQAd__"